import styled from 'styled-components';
import { StyledModal } from '../../../common/shared/modal.styled';
import { colors } from '../../../common/ui/globalColors';
import cubes from '../../../images/newDesign/cubes.svg';

export const BorderedPageWrapperStyled = styled.div`
    font-family: var(--bllink-font-primary); 

    .title-wrapper {
        h1 {
            font-size: 26px;
            line-height: 30px;
        }
    }
  
    .empty-table {
      opacity: .5;
      text-align: center;
      padding: 20vh 0;
      flex: 1 0 1px;
    }

    #section-to-print {
        position: absolute; 
        bottom: 5000px;
        width: 100%;

        .cards-wrapper {
            .cards-body {
                flex-direction: column;
            }
        }
    }

    .ScrollbarsCustom-Wrapper {
        margin-right: 20px;
    }

    .building-address {
        margin-inline-start: 10px;
        color: var(--bllink-purple);
    }

    .main-subtitle {
        font-weight: 700;
        font-size: 20px;
        line-height: 23px;
        color: rgba(55, 54, 71, 0.7);
        margin-top: 12px;
    }

    .main-wrapper {
        border: 1px solid #D8D2FF;
        border-radius: 28px;
        display: flex;
        
        .first-container {
            padding: 33px 25px;
            border-inline-end: 1px solid #D8D2FF;
            width: 57%;
            flex: 1 0 1px;

            .top-bar-large {
                direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
                margin-right: 5px;
            }

            .top-bar, .top-bar-large {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 36px;

                .total-apartments {
                    font-size: 17px;
                    color: rgba(55, 54, 71, 0.7);
                    margin-inline-end: 40px;

                    span {
                        font-weight: 700;
                    }
                }

                .search {
                    position: relative;
                    font-size: 15px;
                    line-height: 24px;
                    color: ${props => props.theme.text};
                    width: 170px;
              
                    input {
                      padding: 8px 20px;
                      padding-inline-end: 40px;
                      border: none;
                      border-radius: 25px;
                      box-shadow: 0 3px 10px rgba(89, 102, 137, .12);
                      width: 100%;
                    }
              
                    img {
                      position: absolute;
                      left: ${({ ltr }) => ltr ? '' : '15px'};
                      right: ${({ ltr }) => ltr ? '15px' : ''};
                      top: 50%;
                      transform: translateY(-50%);
                      width: 20px;
                    }
                }
            }

            .top-bar-large {
                margin-bottom: 23px;
                align-items: flex-end;

                .top-bar-inner {
                    gap: 27px;
                    display: flex;
                    flex-direction: column;

                    img {
                        height: 40px;
                        width: 40px;
                    }
                }

                .top-bar-inner.second {
                    gap: 27px;
                    align-items: flex-end;
                }

                .app-btn {
                    max-width: 170px;
                }

                .total-apartments {
                    margin: 0;
                }
            }

            .cards-wrapper {
                display: flex;
                flex-direction: column;
                gap: 22px;
                padding-right: 1px;
                margin-right: 5px;
            }
        }
      
        .second-container.empty-table {
            margin-top: 165px;
        }
    }
`

export const InfoCardStyled = styled.div`
    background: #FFFFFF;
    border: ${({ selected }) => selected ? `1px solid ${colors.textColors.blue}` : ''};
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 15px;
    padding: 15px 20px;
    cursor: pointer;
    direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};

    :hover {
        border: 1px solid ${colors.textColors.blue};
    }

    .card-title {
        font-weight: 700;
        font-size: 20px;
        line-height: 25px;
        padding-bottom: 14px;
        margin-bottom: 13px;
        border-bottom: 1px solid rgba(216, 210, 255, 0.5);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title-icons-wrapper {
            display: flex;
            gap: 10px;
            height: 21px;
        }
    }

    .tenant-card-body, .cards-body {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        font-size: 14px;
        color: rgba(55, 54, 71, 0.7);
        margin-top: 11px;

        .inner-title {
            line-height: 25px;
        }

        .value {
            font-weight: 700;
            margin: 2px 0 7px;
            height: 21px;
            font-size: 14px;
            line-height: 22px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .value.name {
            max-width: 110px;
        }

        .value.email {
            max-width: 130px;
        }
    }

    .cards-body {
        display: flex;
        justify-content: space-between;
    }
`

export const ContactCardStyled = styled.div`
    background: #FFFFFF;
    border: ${({ selected }) => selected ? `1px solid ${colors.textColors.blue}` : ''};
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 15px;
    padding: 13px 20px;
    cursor: ${({ cursor }) => cursor};
    direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
`;

export const ApartmentInfoStyled = styled.div`
    background: url(${cubes}) #FFFFFF no-repeat bottom left;
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 15px;
    width: ${({ debtList }) => debtList ? '43%' : '40%'};
    margin: 29px 24px;
    padding: ${({ debtList }) => debtList ? '33px 48px' : '34px 20px'};

    .actions-button {
        height: 32px;
    }
  
    .top-container, .total-contacts {
        display: flex;
        justify-content: space-between;
        font-weight: 700;
        font-size: 20px;
        color: ${colors.textColors.black};

        .app-btn {
            width: 150px;
            min-width: auto;
        }
    }

    .total-contacts, .apt-details-header {
        margin-top: 30px;
        font-weight: 700;
        font-size: 16px;
        color: rgba(55, 54, 71, 0.7);
    }

    .total-contacts {
        font-size: 17px;
        align-items: center;

        .tool {
            width: 32px;
            height: 32px;
            background-color: ${colors.additionalColors.lightGray};
            border-radius: 50px;
            cursor: pointer;
            left: 3px;
            top: 10px;
            display: flex;
            flex-direction: column;
            gap: 3px;
            align-items: center;
            justify-content: center;
            box-shadow: -2px 3px 7px 0 ${colors.semiTransparentColors.gray};
    
            .dot {
                background-color: var(--bllink-purple);
                width: 3px;
                height: 3px;
                border-radius: 50px;
            }
    
            :hover {
                background: linear-gradient(180deg, ${colors.additionalColors.brightBlue} 0%, ${colors.additionalColors.purple} 100%);
                color: ${colors.textColors.white};
    
                .dot {
                    background-color: ${colors.textColors.white};
                }
            }
        }
    }

    .apt-details-header {
        margin-top: 31px;
    }

    .contact-info {
        margin-top: 20px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
        gap: 22px;
        font-size: 14px;
        color: rgba(55, 54, 71, 0.7);
        border-bottom: ${({ edit, add }) => edit || add ? 'none' : '1px solid rgba(216, 210, 255, 0.5)'};
        padding-bottom: 34px;
        position: relative;

        .inner-title {
            line-height: 25px;
        }

        .value {
            font-weight: 700;
            margin-bottom: 6px;
            font-size: 17px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .primary-star {
            position: absolute;
            left: ${({ ltr }) => ltr ? '-23px' : ''};
            right: ${({ ltr }) => ltr ? '' : '-23px'};
            top: 3px;
        }
    }

    .contact-info.no-border {
        border: none;
        padding-bottom: 5px;
    }

    .contact-info.flex {
        display: flex;
        justify-content: space-between;
        padding-bottom: 70px;
      
        .value {
            margin-bottom: 0;
        }

        .value.nowrap {
            white-space: nowrap;
        }

        .value.comment {
            max-width: 200px;
        }
    }

    .action-icons {
        margin-top: 33px;
        padding-bottom: 70px;
        border-bottom: ${({ edit, add }) => edit || add ? 'none' : '1px solid rgba(216, 210, 255, 0.5)'};

        .icons-wrapper {
            display: flex;
            gap: 27px;
            justify-content: center;
            margin-bottom: 20px;

            img {
                cursor: pointer;
            }
        }

        .arrows {
            display: flex;
            gap: 17px;
            justify-content: center;
            direction: ${({ ltr }) => ltr? 'ltr' : 'rtl'};

            .arrow {
                width: 32px;
                height: 32px;
                background: ${colors.additionalColors.lightGray};
                border-radius: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }

            .arrow.next {
                transform: ${({ ltr }) => ltr ? 'rotate(180deg)' : 'rotate(0deg)'};
            }

            .arrow.prev {
                transform: ${({ ltr }) => ltr ? 'rotate(0deg)' : 'rotate(180deg)'};
            }
        }
    }

    .action-icons.padding-bottom {
        padding-bottom: 36px;
    }

    .monthly-fee {
        font-weight: 700;
        font-size: 20px;
        color: ${colors.textColors.black};
        display: flex;
        gap: 10px;
        margin-top: 17px;
    }

    .input {
        label {
            margin-bottom: 0;
        }

        .bllink-input-border {
            border: none;
            border-bottom: 1px solid rgba(110, 116, 255, 0.4);
            background-color: transparent;
            border-radius: 0;
            padding: 0;
            font-size: 14px;
            height: 30px;
            margin-left: 2px;
        }
    }

    .button-wrapper {
        display: flex;
        justify-content: flex-end;

        .app-btn {
            width: 132px;
            min-width: unset;
        }
    }
`

export const StyledAddContactModal = styled(StyledModal)`
    font-family: var(--bllink-font-primary);

    .modal-dialog .modal-body {
        padding: 50px 200px;
        display: flex;
        flex-direction: column;

        .input {
            margin-bottom: 31px;
            direction: ${(({ ltr }) => ltr ? 'ltr' : 'rtl')};
    
            label {
                margin-bottom: 8px !important;
                font-size: 17px;
            }
    
            .bllink-input-border {
                border: none;
                border-bottom: 1px solid rgba(110, 116, 255, 0.4);
                background-color: transparent;
                border-radius: 0;
                padding: 0;
                font-size: 14px;
                height: 30px;
                margin-left: 2px;
            }
        }

        .dropdown-wrapper {
            margin-bottom: 31px;

            label {
                margin-bottom: 8px !important;
            }
        }

        .checkbox-label {
            font-size: 17px !important;
            font-weight: 400 !important;
        }

        .app-btn {
            width: 150px;
            align-self: center;
            margin-top: 20px;
        }
    }
`
